import { classnames } from '@aibees/shared/utils';
import { LoadingButton } from '@mui/lab';
import { Box, Button } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DialogActionsProps as Props } from './types';

export const DialogActions = memo(
  ({
    className,
    submitTitle,
    hasClearButton,
    hasSelectAllButton,
    formId,
    disabled,
    loading,
    onClose,
    onSubmit,
    submitButtonProps,
    onClear,
    clearButtonProps,
    selectAllButtonProps,
    onSelectAll,
    customLeftActions,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('DialogActions', className)}
        sx={SX.root}
      >
        <Box display="flex" gap={1} alignItems="center">
          {customLeftActions}
          {hasSelectAllButton && (
            <Button
              children="Select All"
              variant="text"
              color="default"
              size="small"
              onClick={onSelectAll}
              {...selectAllButtonProps}
            />
          )}

          {hasClearButton && (
            <Button
              children="Clear All"
              variant="text"
              color="default"
              size="small"
              onClick={onClear}
              {...clearButtonProps}
            />
          )}
        </Box>

        <Box
          display="flex"
          gap={1}
          alignItems="center"
          justifyContent="flex-end"
          width="100%"
        >
          <Button
            children="Cancel"
            variant="text"
            color="default"
            size="small"
            onClick={onClose}
          />

          <LoadingButton
            form={formId}
            type="submit"
            children={submitTitle ?? 'Save'}
            variant="contained"
            color="primary"
            size="small"
            disabled={disabled}
            loading={loading}
            onClick={onSubmit}
            {...submitButtonProps}
          />
        </Box>
      </Styled.Wrapper>
    );
  }
);

DialogActions.displayName = 'DialogActions';
